import { TileActions } from "components/dynamic-content/util/dynamicContent"
import TalkToCarrotTilePage from "components/talk-to-carrot/TalkToCarrotTilePage"
import { HelpNode } from "components/talk-to-carrot/util/talkToCarrotMolecules"
import { ITilePage } from "contentful-types"
import React from "react"
import { ReactElement } from "react"
import { fieldIsValid, getPathForTile } from "../utils/mappingUtils"
import { GuidanceElement } from "./GuidanceElement"
import { TileElement } from "./TileElement"

type TTCTilePageElementProps = {
  page: ITilePage
  actions: TileActions
  baseUrl: string
}

const TTCTilePageElement = ({
  page,
  actions,
  baseUrl
}: TTCTilePageElementProps): ReactElement<typeof TalkToCarrotTilePage> => {
  const {
    fields: { guidance, tiles }
  } = page

  return (
    <>
      {tiles && fieldIsValid(guidance) ? (
        <TalkToCarrotTilePage
          guidance={<GuidanceElement guidance={guidance} />}
          tiles={tiles.filter(fieldIsValid).map((tile) => (
            <TileElement
              tile={tile}
              actions={actions}
              baseUrl={baseUrl}
              key={`${getPathForTile({ tile, baseUrl })}_tile`}
            />
          ))}
          helpNode={<HelpNode baseUrl={baseUrl} />}
        />
      ) : null}
    </>
  )
}

export { TTCTilePageElement }
